import { render, staticRenderFns } from "./PaymentsCollected.vue?vue&type=template&id=0ff0b568&scoped=true"
import script from "./PaymentsCollected.vue?vue&type=script&lang=js"
export * from "./PaymentsCollected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff0b568",
  null
  
)

export default component.exports